import React from "react";
import StaffViewOwnAttendance from "../../components/StaffTabs/StaffViewOwnAttendance/StaffViewOwnAttendance";

const TakeOwnAttendance = () => {
  return (
    <div>
      
      <StaffViewOwnAttendance/>
    </div>
  );
};

export default TakeOwnAttendance;
